import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CorteProveedorService } from 'src/app/services/corteProveedor.service';
import { GenericFormHandlerService } from 'src/app/shared/generic-crud.service';
import { controlHttp } from 'src/app/shared/models/form.models';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CortesDialogMobileComponent } from './cortes-dialog-mobile/cortes-dialog-mobile.component';
import moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: 'app-cortes-dialog',
  templateUrl: './cortes-dialog.component.html',
  styleUrls: ['./cortes-dialog.component.scss']
})
export class CortesDialogComponent extends GenericFormHandlerService implements OnInit {
  corteDetalles: any;
  private isHandset = false;

  constructor(
    protected corteService: CorteProveedorService,
    protected toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<CortesDialogComponent>,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {
    super(corteService, toastr, dialogRef);
    this.configureBasedOnData();
    this.breakpointObserver.observe([Breakpoints.Handset, '(max-width: 750px)']).subscribe(result => {
      this.isHandset = result.matches;
    });
  }

  ngOnInit(): void {
    if (this.isHandset) {
      this.dialog.open(CortesDialogMobileComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        panelClass: 'cortes-dialog-mobile-panel',
        autoFocus: false,
        data: this.data
      });
      this.dialogRef.close();
      return;
    }

    this.obtenerDetalles();
    this.initializeForm(false);
  }

  private configureBasedOnData(): void {
    this.currentOperation = controlHttp.READ;
    if (this.data.corte) {
      this.apiIdentifier = this.data.corte.id;
    }
  }

  getEstadoColor(estado: string): string {
    switch (estado) {
      case 'pagado': return 'primary';
      case 'pendiente': return 'accent';
      case 'cancelado': return 'warn';
      default: return '';
    }
  }

  obtenerDetalles(): void {
    this.isLoading = true;
    const corteId = this.data?.corte?.id;
    if (!corteId) {
      this.toastr.error('No se proporcionó un ID de corte válido');
      this.isLoading = false;
      return;
    }

    this.corteService.obtenerCortePorId(corteId).subscribe({
      next: (corte) => {
        this.corteDetalles = corte;
        this.isLoading = false;
      },
      error: (error) => {
        const errorMessage = this.extractErrorMessage(error);
        this.toastr.error(errorMessage || 'Error al cargar los datos del corte');
        this.isLoading = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef?.close();
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return '-';
    return moment(fecha).locale('es').format('DD [de] MMMM YYYY, HH:mm');
  }

  formatearMoneda(valor: string | number): string {
    const num = typeof valor === 'string' ? parseFloat(valor) : valor;
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(num);
  }

  calcularSaldoPendiente(): number {
    if (!this.corteDetalles) return 0;
    const total = typeof this.corteDetalles.montoTotal === 'string' 
      ? parseFloat(this.corteDetalles.montoTotal) 
      : this.corteDetalles.montoTotal;
    const pagado = typeof this.corteDetalles.montoPagado === 'string' 
      ? parseFloat(this.corteDetalles.montoPagado) 
      : this.corteDetalles.montoPagado;
    return total - pagado;
  }
}

interface DialogData {
  corte?: any;
  isEdit?: boolean;
}

